// extracted by mini-css-extract-plugin
export default {"mention":"MentionText_mention__cRdOn","mentionEveryone":"MentionText_mentionEveryone__ExFhr"};